(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(section) {
    const img = section.querySelector('.bauc__img');
    if (!img) return;

    // ← No aplicar rotación a vídeos
    if (img.tagName === 'VIDEO') return;

    let raf = null;
    function update() {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
      const rotate = -progress * 6;
      img.style.transform = `rotate(${rotate}deg)`;
      raf = null;
    }
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  document.querySelectorAll('.bauc').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.bauc');
    if (section) init(section);
  });
})();